import React from 'react';
import { Element } from 'react-scroll';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';

const advantages = [
  {
    title: "Government Regulators",
    description: "Automate monitoring and issue classification, enabling faster enforcement and policy responses.",
  },
  {
    title: "Public Service Agencies",
    description: "Use AI agents to personalize employment services and automate client outcomes tracking.",
  },
  {
    title: "Edge AI Implementers",
    description: "Deploy MEA devices to local offices for offline data processing in high-privacy contexts.",
  },
  {
    title: "Civic Tech Collaborators",
    description: "Integrate our APIs with civic platforms to deliver next-gen user experiences for licensing, reporting, and feedback.",
  },
  {
    title: "Policy & Evaluation Teams",
    description: "Leverage our dashboards to monitor real-time KPIs, sentiment shifts, and service trends.",
  },
  {
    title: "Research & Innovation Hubs",
    description: "Partner on responsible AI use, ethics-by-design, and inclusive technology testing in public policy.",
  },
]

const Advantage = () => {
  return (
    <>
      <Element
        name="Advantage"
        className="datatalent-section-gap solutions-advantage"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center text-white"
                title = "Public Sector Ecosystem Integration"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center color-white">Cross-Sectoral AI Tools Built for Governments, Agencies & Nonprofits.</p>
            </div>
            {advantages.map((adv) =>
              <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5" key={adv.title}>
                <div className="advantage-card p-4 h-100">
                  <h5 className="mt-3 mb-3 color-white">{adv.title}</h5>
                  <p className="mb-3">{adv.description}</p>
                </div>
            </div>
            )}
          </div>
        </div>
      </Element>
    </>
  )
}

export default Advantage;